import { RiTwitterXFill } from 'react-icons/ri';
import { FaFacebookF, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { ClientNames } from '../enums/client-names.enum';
export const SOCIAL_MEDIAS = [
    {
        Icon: FaFacebookF,
        url: 'https://facebook.com/DesignsdotAIOfficial',
        name: 'facebook'
    },
    {
        Icon: FaInstagram,
        url: 'https://www.instagram.com/DesignsdotAI/',
        name: 'instagram'
    },
    {
        Icon: RiTwitterXFill,
        url: ' https://twitter.com/DesignsdotAI',
        name: 'twitter'
    },
    {
        Icon: FaLinkedin,
        url: ' https://www.linkedin.com/company/designs-ai/',
        name: 'linkedin'
    }
    // {
    //   Icon: FaYoutube,
    //   url: ' https://www.youtube.com/channel/UCHlJ9ySy3e7gQRQKaa4SUHA/',
    //   name: 'youtube'
    // }
];
export const LANGUAGES = [
    { code: 'en', url: '/en', name: 'English', locale: 'en' },
    { code: 'id', url: '/id', name: 'Bahasa Indonesia', locale: 'id' },
    { code: 'cz', url: '/cz', name: 'Czech', locale: 'cz' },
    { code: 'de', url: '/de', name: 'Deutsch', locale: 'de' },
    { code: 'es', url: '/es', name: 'Español', locale: 'es' },
    { code: 'fr', url: '/fr', name: 'Français', locale: 'fr' },
    { code: 'it', url: '/it', name: 'Italiano', locale: 'it' },
    { code: 'pl', url: '/pl', name: 'Język polski', locale: 'pl' },
    { code: 'pt', url: '/pt', name: 'Português', locale: 'pt' },
    { code: 'ru', url: '/ru', name: 'Русский язык', locale: 'ru' },
    { code: 'tr', url: '/tr', name: 'Türkçe', locale: 'tr' },
    { code: 'cn', url: '/cn', name: '中文 (简体)', locale: 'zh-Hans' },
    { code: 'tw', url: '/tw', name: '中文 (繁體)', locale: 'zh-Hant' },
    { code: 'jp', url: '/jp', name: '日本語', locale: 'jp' },
    { code: 'kr', url: '/kr', name: '한국어', locale: 'kr' }
];
export const TABS_NAME = [
    { name: 'Create' },
    { name: 'Tools' },
    { name: 'Resources' },
    { name: 'Pricing' }
];
export const CREATE = [
    {
        name: ClientNames.ai_audio,
        shortName: 'AI',
        color: 'orange',
        title: 'AI Audio',
        lang_key: 'ai_audio',
        url: '/ai-audio',
        link: '/ai-audio/start',
        descriptionKey: 'aiaudio_description',
        description: 'Text to lifelike speech synthesis',
        png: 'https://assets.designs.ai/images/main-index-png/icon_ai_audio.svg',
        gtm: { id: 'ai audio', name: 'ai audio', category: 'tools/ai-audio' }
    },
    {
        name: ClientNames.ai_chat,
        shortName: 'AI',
        color: 'orange',
        title: 'AI Chat',
        lang_key: 'ai_chat',
        url: '/ai-chat',
        link: '/ai-chat/start',
        descriptionKey: 'aichat_description',
        description: 'Powerful AI models in one platform',
        png: 'https://assets.designs.ai/images/main-index-png/icon_ai_chat.svg',
        gtm: { id: 'ai chat', name: 'ai chat', category: 'tools/ai-chat' }
    },
    {
        name: ClientNames.ai_design,
        shortName: 'AI',
        color: 'orange',
        title: 'AI Design',
        lang_key: 'ai_design',
        url: '/ai-design',
        link: '/ai-design/start',
        descriptionKey: 'aidesign_description',
        description: 'Craft captivating designs effortlessly',
        png: 'https://assets.designs.ai/images/main-index-png/icon_ai_design.svg',
        gtm: { id: 'ai design', name: 'ai design', category: 'tools/ai-design' }
    },
    {
        name: ClientNames.ai_draw,
        shortName: 'AI',
        color: 'orange',
        title: 'AI Draw',
        lang_key: 'ai_draw',
        url: '/imagemaker',
        link: '/imagemaker/start/ai-draw',
        descriptionKey: 'aidraw_description',
        description: 'Turn drawings into visually captivating masterpieces',
        png: 'https://assets.designs.ai/images/main-index-png/icon_ai_draw.svg',
        gtm: { id: 'ai draw', name: 'ai draw', category: 'tools/ai-draw' }
    },
    {
        name: ClientNames.copywriter,
        shortName: 'Copy',
        lang_key: 'copywriter',
        description: 'Elevate your marketing and SEO-friendly content game',
        descriptionKey: 'copywriter_description',
        png: 'https://assets.designs.ai/images/main-index-png/icon_cw.svg',
        url: '/copywriter',
        link: '/copywriter/start',
        color: 'blue',
        title: 'AI Writer',
        gtm: { id: 'copywriter', name: 'copywriter', category: 'tools/copywriter' }
    },
    {
        keys: 'de',
        name: ClientNames.designmaker,
        shortName: 'Designs',
        lang_key: 'designs',
        url: '/designmaker',
        link: '/designmaker/start',
        description: 'Stunning visual content with dynamic templates',
        descriptionKey: 'designmaker_description',
        png: 'https://assets.designs.ai/images/main-index-png/icon_dm.svg',
        title: 'Design maker',
        color: 'orange',
        gtm: {
            id: 'designmaker',
            name: 'Designmaker',
            category: 'tools/designmaker'
        }
    },
    {
        name: ClientNames.faceswapper,
        shortName: 'Face',
        lang_key: 'faceswapper',
        description: 'Electrify your media with face-swapping magic',
        descriptionKey: 'faceswapper_description',
        png: 'https://assets.designs.ai/images/main-index-png/icon_fs_c1.svg',
        url: '/faceswapper',
        link: '/faceswapper',
        color: 'orange',
        title: 'Face Swapper',
        gtm: {
            id: 'faceswapper',
            name: 'faceswapper',
            category: 'tools/faceswapper'
        }
    },
    {
        name: ClientNames.imagemaker,
        shortName: 'Image',
        lang_key: 'imagemaker',
        description: 'Infinite world of visual possibilities',
        descriptionKey: 'imagemaker_description',
        png: 'https://assets.designs.ai/images/main-index-png/icon_im.svg',
        url: '/imagemaker',
        link: '/imagemaker/start',
        color: 'cyan',
        title: 'Image Maker',
        gtm: { id: 'imagemaker', name: 'imagemaker', category: 'tools/imagemaker' }
    },
    {
        name: ClientNames.logomaker,
        shortName: 'Logos',
        lang_key: 'logos',
        image: '/static/logo_lm.png',
        imageMobile: '/static/logo_lm.png',
        url: '/logomaker',
        link: '/logomaker/start',
        description: 'AI-generated brand logos and brand kits',
        descriptionKey: 'logomaker_description',
        png: 'https://assets.designs.ai/images/main-index-png/icon_lm.svg',
        title: 'Logo Maker',
        color: 'magenta',
        gtm: { id: 'logomaker', name: 'Logomaker', category: 'tools/logomaker' }
    },
    {
        name: ClientNames.videomaker,
        shortName: 'Videos',
        lang_key: 'videos',
        image: '/static/logo_vm.png',
        imageMobile: '/static/logo_vm.png',
        url: '/videomaker',
        link: '/videomaker/start',
        description: 'Instant videos for multi platform campaigns',
        descriptionKey: 'videomaker_description',
        png: 'https://assets.designs.ai/images/main-index-png/icon_vm.svg',
        title: 'Video Maker',
        color: 'green',
        gtm: { id: 'videomaker', name: 'Videomaker', category: 'tools/videomaker' }
    }
    // {
    //   name: ClientNames.speechmaker,
    //   shortName: 'Speech',
    //   lang_key: 'speech',
    //   description: 'Natural-sounding voices from text script',
    //   descriptionKey: 'speechmaker_description',
    //   png: 'https://assets.designs.ai/images/main-index-png/icon_sm.svg',
    //   url: '/speechmaker',
    //   link: '/speechmaker/start',
    //   color: 'purple',
    //   title: 'Speech Maker',
    //   gtm: {
    //     id: 'speechMaker',
    //     name: 'speechMaker',
    //     category: 'tools/speechMaker'
    //   }
    // },
    // {
    //   name: ClientNames.copywriter,
    //   shortName: 'Copy',
    //   lang_key: 'copywriter',
    //   description: 'Converts text from images into editable digital formats',
    //   descriptionKey: 'capgen_description',
    //   png: 'https://assets.designs.ai/images/main-index-png/icon_img2txt.svg',
    //   url: '/copywriter',
    //   link: '/copywriter/start/image-to-text/caption-generator',
    //   color: 'blue',
    //   title: 'AI Image to Text',
    //   gtm: { id: 'copywriter', name: 'copywriter', category: 'tools/copywriter' }
    // }
];
export const MAIN_TOOLS = [
    {
        name: ClientNames.designs_ai,
        image: 'https://assets.designs.ai/images/dsai-logo/default.webp',
        png: 'https://assets.designs.ai/images/dsai-logo/default.png',
        imageMobile: 'https://assets.designs.ai/images/dsai-logo/default.webp',
        imageMobilePng: 'https://assets.designs.ai/images/dsai-logo/default.png',
        url: '/',
        color: 'orange'
    },
    {
        name: ClientNames.ai_audio,
        shortName: 'AI',
        color: 'orange',
        title: 'AI Audio',
        lang_key: 'ai_audio',
        url: '/ai-audio',
        link: '/ai-audio/start',
        descriptionKey: 'aichat_description',
        description: 'Powerful AI models in one platform',
        png: 'https://assets.designs.ai/images/main-index-png/icon_ai_chat.svg',
        gtm: { id: 'ai audio', name: 'ai audio', category: 'tools/ai-audio' }
    },
    {
        name: ClientNames.ai_chat,
        shortName: 'AI',
        color: 'orange',
        title: 'AI Chat',
        lang_key: 'ai_chat',
        url: '/ai-chat',
        link: '/ai-chat/start',
        descriptionKey: 'aichat_description',
        description: 'Powerful AI models in one platform',
        png: 'https://assets.designs.ai/images/main-index-png/icon_ai_chat.svg',
        gtm: { id: 'ai chat', name: 'ai chat', category: 'tools/ai-chat' }
    },
    {
        name: ClientNames.ai_design,
        shortName: 'AI',
        color: 'orange',
        title: 'AI Design',
        lang_key: 'ai_design',
        url: '/ai-design',
        link: '/ai-design/start',
        descriptionKey: 'aidesign_description',
        description: 'Craft captivating designs effortlessly',
        png: 'https://assets.designs.ai/images/main-index-png/icon_ai_design.svg',
        gtm: { id: 'ai design', name: 'ai design', category: 'tools/ai-design' }
    },
    {
        name: ClientNames.copywriter,
        shortName: 'Copy',
        color: 'blue',
        url: '/copywriter',
        title: 'AI Writer',
        lang_key: 'copywriter',
        descriptionKey: 'copywriter_description',
        link: '/copywriter/start/image-to-text/caption-generator',
        description: 'Elevate your marketing and SEO-friendly content game',
        png: 'https://assets.designs.ai/images/main-index-png/icon_cw.svg',
        gtm: { id: 'copywriter', name: 'copywriter', category: 'tools/copywriter' }
    },
    //   name: ClientNames.ai_draw,
    //   shortName: 'AI',
    //   color: 'orange',
    //   title: 'AI Draw',
    //   lang_key: 'ai_draw',
    //   url: '/imagemaker/start/ai-draw',
    //   link: '/imagemaker/start/ai-draw',
    //   descriptionKey: 'aidraw_description',
    //   description: 'Turn drawings into visually captivating masterpieces',
    //   png: 'https://assets.designs.ai/images/main-index-png/icon_ai_draw.svg',
    //   gtm: { id: 'ai draw', name: 'ai draw', category: 'tools/ai-draw' }
    // },
    {
        name: ClientNames.faceswapper,
        shortName: 'Face',
        lang_key: 'faceswapper',
        description: 'Electrify your media with face-swapping magic',
        descriptionKey: 'faceswapper_description',
        png: 'https://assets.designs.ai/images/main-index-png/icon_fs_c1.svg',
        url: '/faceswapper',
        link: '/faceswapper',
        color: 'orange',
        title: 'Face Swapper',
        gtm: {
            id: 'faceswapper',
            name: 'faceswapper',
            category: 'tools/faceswapper'
        }
    },
    // {
    //   name: ClientNames.imagemaker,
    //   shortName: 'Image',
    //   lang_key: 'imagemaker',
    //   description: 'Infinite world of visual possibilities',
    //   descriptionKey: 'imagemaker_description',
    //   png: 'https://assets.designs.ai/images/main-index-png/icon_im.svg',
    //   url: '/imagemaker',
    //   link: '/imagemaker/start',
    //   color: 'cyan',
    //   title: 'Image Maker',
    //   gtm: {
    //     id: 'imagemaker',
    //     name: 'imagemaker',
    //     category: 'tools/imagemaker'
    //   }
    // },
    // {
    //   name: ClientNames.videomaker,
    //   image: '/static/logo_vm.png',
    //   imageMobile: '/static/logo_vm.png',
    //   url: '/videomaker',
    //   description: 'Instant videos for multi platform campaigns',
    //   descriptionKey: 'videomaker_description',
    //   png: 'https://assets.designs.ai/images/header-png/header-videomaker.png',
    //   title: 'Video Maker',
    //   color: 'cyan',
    //   gtm: {
    //     id: 'videomaker',
    //     name: 'Videomaker',
    //     category: 'tools/videomaker'
    //   }
    // },
    {
        name: ClientNames.logomaker,
        image: '/static/logo_lm.png',
        imageMobile: '/static/logo_lm.png',
        url: '/logomaker',
        description: 'AI-generated brand logos and brand kits',
        descriptionKey: 'logomaker_description',
        png: 'https://assets.designs.ai/images/header-png/header-logomaker.png',
        title: 'Logo Maker',
        color: 'magenta',
        gtm: {
            id: 'logomaker',
            name: 'Logomaker',
            category: 'tools/logomaker'
        }
    },
    // {
    //   name: ClientNames.designmaker,
    //   url: '/designmaker',
    //   description: 'Stunning visual content with dynamic templates',
    //   descriptionKey: 'designmaker_description',
    //   png: 'https://assets.designs.ai/images/header-png/header-designmaker.png',
    //   title: 'Design Maker',
    //   color: 'orange',
    //   gtm: {
    //     id: 'designmaker',
    //     name: 'Designmaker',
    //     category: 'tools/designmaker'
    //   }
    // },
    {
        name: ClientNames.speechmaker,
        description: 'Natural-sounding voices from text script',
        descriptionKey: 'speechmaker_description',
        png: 'https://assets.designs.ai/images/header-png/header-speechmaker.png',
        url: '/speechmaker',
        color: 'purple',
        title: 'Speech Maker',
        gtm: {
            id: 'speechMaker',
            name: 'speechMaker',
            category: 'tools/speechMaker'
        }
    }
];
export const MINI_TOOLS = [
    {
        slug: 'color_matcher',
        title: 'Color Matcher',
        shortName: 'Color',
        lang_key: 'color',
        name: ClientNames.color_matcher,
        image: 'colormatcher.png',
        url: '/colors',
        link: '/colors',
        outside: true,
        target: '_blank',
        info: 'Use AI to match colors for the perfect palette',
        png: 'https://assets.designs.ai/images/main-index-png/icon_cm.svg',
        description: 'color_matcher_description',
        description_clean: 'color_matcher_description',
        gtm: {
            id: 'colormatcher',
            name: 'Color Matcher',
            category: 'tools/colormatcher'
        }
    },
    {
        slug: 'graphicmaker',
        title: 'Graphic Maker',
        shortName: 'Graphic',
        lang_key: 'graphic',
        name: 'Graphic Maker',
        image: 'graphicmaker.png',
        url: '/graphicmaker',
        link: '/graphicmaker',
        outside: true,
        target: '_blank',
        info: 'Free SVG vectors with in-browser editor',
        png: 'https://assets.designs.ai/images/main-index-png/icon_gm.svg',
        description: 'graphicmaker_description',
        description_clean: 'graphicmaker_description',
        gtm: {
            id: 'graphicmaker',
            name: 'Graphicmaker',
            category: 'tools/graphicmaker'
        }
    },
    {
        slug: 'font_pairer',
        title: 'Font Pairer',
        shortName: 'Font',
        lang_key: 'font',
        name: ClientNames.fontpairer,
        image: 'font-pairer.png',
        url: '/fonts',
        link: '/fonts',
        outside: true,
        target: '_blank',
        info: 'Generate stunning font combinations with AI',
        png: 'https://assets.designs.ai/images/main-index-png/icon_fp.svg',
        description: 'font_pairer_description',
        description_clean: 'font_pairer_description',
        gtm: {
            id: 'fontpairer',
            name: 'Font Pairer',
            category: 'tools/fontpairer'
        }
    },
    {
        slug: 'calendar',
        title: 'Calendar',
        shortName: 'Calendar',
        lang_key: 'calendar',
        name: ClientNames.calendar,
        image: 'calendar.gif',
        url: '/calendar',
        link: '/calendar',
        outside: true,
        target: '_blank',
        info: 'A collection of social holidays and events',
        png: 'https://assets.designs.ai/images/main-index-png/icon_calendar.svg',
        description: 'calendar_description',
        description_clean: 'calendar_description',
        gtm: {
            id: 'calendar',
            name: 'Calendar',
            category: 'tools/Calendar'
        }
    }
];
export const RESOURCES = [
    {
        name: 'Tutorials',
        title: 'Tutorial',
        nameKey: 'tutorials',
        url: 'https://www.youtube.com/channel/UCHlJ9ySy3e7gQRQKaa4SUHA',
        target: '_blank',
        outside: true,
        png: 'https://assets.designs.ai/images/main-index-png/icon_tutorial.svg',
        description: 'Quick simple tutorials to get started',
        descriptionKey: 'tutorial_description'
    },
    {
        name: 'Blog',
        title: 'Blog',
        nameKey: 'blog',
        url: 'https://designs.ai/blog/',
        target: '_blank',
        outside: true,
        png: 'https://assets.designs.ai/images/main-index-png/icon_blog.svg',
        description: 'Learn more about AI, design and marketing',
        descriptionKey: 'blog_description'
    },
    {
        title: 'Affiliate',
        name: 'Affiliate',
        nameKey: 'affiliate',
        url: '/affiliate',
        target: '_blank',
        outside: true,
        png: 'https://assets.designs.ai/images/main-index-png/icon_affiliate.svg',
        description: 'Help us expand our growing community',
        descriptionKey: 'affiliate_description'
    },
    {
        title: 'Agencies',
        name: 'For Agencies',
        nameKey: 'agencies',
        url: '/agency',
        target: '_blank',
        outside: true,
        png: 'https://assets.designs.ai/images/main-index-png/icon_agencies.svg',
        description: 'Scale your creative production with AI',
        descriptionKey: 'for_agencies_description'
    }
];
export const INDUSTRIES = [
    { name: 'Agencies', url: '/agency', target: '_blank', outside: true },
    { name: 'F&B', url: '', target: '_blank', outside: true },
    { name: 'Home Businesses', url: '', target: '_blank', outside: true },
    { name: 'Medical Services', url: '', target: '_blank', outside: true },
    { name: 'Properties realtors', url: '', target: '_blank', outside: true },
    { name: 'Hospitality', url: '', target: '_blank', outside: true },
    { name: 'Startups', url: '', target: '_blank', outside: true }
];
//# sourceMappingURL=global.constant.js.map